exports.phrases = {
    Landing: {
      header1: 'Ένα πληροφοριακό σύστημα είναι τόσο καλό όσο η ποιότητα των δεδομένων του.',
      paragraph1: 'To Identify είναι μια εφαρμογή παρακολούθησης της ποιότητας των εγγραφών που περιέχονται στα πληροφοριακά συστήματα των Ιδρυμάτων.',
      header2: 'Στόχος',
      paragraph2: 'Στόχος αυτής της εφαρμογής είναι να παρέχει τη δυνατότητα άμεσης, εύκολης και σφαιρικής πληροφόρησης σχετικά με την ποιότητα δεδομένων που περιέχουν τα πληροφοριακά συστήματα των ιδρυμάτων, διευκολύνοντας τον εντοπισμό αποκλίσεων και τη διαρκή βελτίωση της αποθηκευμένης πληροφορίας.',
      header3: 'Ποιούς Αφορά',
      paragraph3: 'Αφορά τους υπεύθυνους των πληροφοριακών συστημάτων και το εξουσιοδοτημένο προσωπικό Ιδρυμάτων.',
      header4: 'Τι προσφέρει',
      paragraph4: 'Το Identify προσφέρει εύκολη πρόσβαση σε πληροφορίες σχετικά με την ποιότητα των εγγραφών στα πληροφοριακά συστήματα.',  
      header5: 'Lol',
      paragraph5: ' Ο εξουσιοδοτημένος χρήστης έχει τη δυνατότητα γρήγορης ενημέρωσης με την πρόσβαση σε στατιστικά ενώ μπορεί να πληροφορηθεί λεπτομερώς σχετικά με τις αποκλίσεις μέσω των αποτελεσμάτων των ελέγχων που έχουν πραγματοποιηθεί στο αντίστοιχο σύστημα και να πραγματοποιήσει αναζητήσεις με βάση τα στοιχεία που των ενδιαφέρουν.',
      paragraph6: 'Τα δεδομένα του Identify ομαδοποιούνται κατάλληλα με βάση τα χαρακτηριστικά τους, ώστε να διευκολύνει τον χρήστη να εστιάσει στα στοιχεία που θεωρεί σημαντικά.',
      paragraph7: 'Περισσότερες πληροφορίες σχετικά με το Identify και την πρόσβαση σε αυτό βρίσκονται στο',
      usersManual: 'Εγχειρίδιο Χρήστη',
      learnMore: 'Μάθε περισσότερα',
      login: 'Σύνδεση',
      overview: 'Στατιστικά'
    },
    overview: "Στατιστικά",
    checks: "Αποτελέσματα",
    login: "Σύνδεση",
    logout: 'Αποσύνδεση',
    contact: 'Επικοινωνία',
    recordInfo: 'Στοιχεία Εγγραφής',
    noMatchingResults: 'Δεν βρέθηκαν αποτελέσματα',
    errCode: 'Κωδικός',
    errDescription: 'Περιγραφή',
    errType: 'Είδος',
    errSeverity: 'Σοβαρότητα',
    errFields: 'Πεδία',
    errValue1: 'Τιμή 1',
    errValue2: 'Τιμή 2',
    invalidMobilePhone: 'Δεν υπάρχει διαθέσιμος έγκυρος αριθμός κινητού τηλεφώνου',
    userAlreadyNotified: 'Οι ενημερώσεις προς αυτόν τον χρήστη έφτασαν τον μέγιστο αριθμό για μια ημέρα',
    usersGuide: 'Εγχειρίδιο Χρήστη Identify',
    accessMailSubject: '<Όνομα Ιδρύματος> Identify, Αίτηση λογαριασμού πρόσβασης',
    runRequestMailSubject: '<Όνομα Ιδρύματος> : Identify, Προγραμματισμός νέου ποιοτικού ελέγχου δεδομένων (SIS)',
    runRequestMailBody: "To φίλτρο με το οποίο θέλουμε να περιορίσουμε τον έλεγχο των στοιχείων του μητρώου, με τη μορφή SQL WHERE clause π.χ. : ",
    runRequestMailClause1: "WHERE enrollmentStatus='active'",
    runRequestMailClause2: "WHERE enrollmentStatus IN ('active', 'interim') AND enrollmentTerm<=4",
    clickToCopy: "Κλικ για Αντιγραφή",
    clickToMail: "Κλικ για Αποστολή e-mail",
    landingPageTitle: 'Identify - Αρχική',
    loginPageTitle: 'Identify - Σύνδεση',
    overviewPageTitle: 'Identify - Στατιστικά',
    resultsPageTitle: 'Identify - Αποτελέσματα',
    help: 'Βοήθεια',
    usersGuide1: 'Εγχειρίδιο Χρήστη',
    helpPageTitle: 'Identify - Εγχειρίδιο Χρήστη',
    helpContents: 'Περιεχόμενα',
    helpIntroduction: 'Εισαγωγή',
    helpRecordQuality: 'Ποιότητα Εγγραφών',
    helpErrorsPerType: 'Αποκλίσεις ανά Είδος',
    helpErrorsPerField: 'Αποκλίσεις ανά Πεδίο',
    helpErrorAnalysis: 'Ανάλυση Αποκλίσεων',
    helpResults: 'Αναλυτικά Αποτελέσματα',
    helpAuthorization: 'Πρόσβαση στην Εφαρμογή',
    helpRunScheduling: 'Προγραμματισμός Νέων Ελέγχων',
    helpRequirements: 'Προϋποθέσεις',
    accessInfo: 'Πως αποκτώ πρόσβαση;',
    errorPageTitle: 'Identify',
    web: 'Ιστός',
    phone: 'Τηλέφωνο',
    email: 'E-mail',
    landing: 'Αρχική',
    goal: 'Στόχος',
    targetGroup: 'Ποιούς Αφορά',
    fetchErrorMessage: 'Κάτι πήγε στραβά!',
    fetchErrorSubtitle: 'Δοκιμάστε ξανά αργότερα',
    fetchErrorLink: 'Επιστροφή στην Αρχική',
    notAuthorizedErrorMessage: 'Φαίνεται πως δεν είστε πλέον συνδεδεμένοι στην εφαρμογή.', 
    downloadFile1: 'Για το κατέβασμα αρχείου που περιέχει τα αναλυτικά αποτέλεσματα, τα οποία προέκυψαν από τους ελέγχους στο μητρώο φοιτητών του ιδρύματος, ',
    downloadFile2: 'ακολουθήστε τον παρακάτω σύνδεσμο',
    fileNotExists1: 'Αυτή την στιγμή δεν είναι διαθέσιμο αρχείο με τα αναλυτικά αποτελέσματα, τα οποία προέκυψαν από τους ελέγχους στο μητρώο φοιτητών του ιδρύματος',
    fileNotExists2: 'Δοκιμάστε ξανά αργότερα',
    resFileUrlName: 'Αναλυτικά Αποτελέσματα Ελέγχων',
    checksResults: 'Αποτελέσματα Ελέγχων',
    errorsPerSeverity: "Ποιότητα Εγγραφών",
    errorsPerProperty: "Αποκλίσεις ανά Πεδίο",
    errorsPerType: "Αποκλίσεις ανά Είδος",
    errorAnalysis: "Ανάλυση Αποκλίσεων",
    faultyRecordsNumber: "Αριθμός Εγγραφών με Αποκλίσεις",
    faultsNumber: "Συνολικός Αριθμός Αποκλίσεων",
    resultsFor: "Αποτελέσματα για",
    allDepartments: "'Ολα τα Τμήματα",
    overviewInfo: 'Στα γραφήματα που αφορούν εγγραφές, τα ποσοστά αφορούν το σύνολο εγγραφών, ενώ σε αυτα που αφορούν αποκλίσεις τα ποσοστά αφορούν το σύνολο αποκλίσεων',
    lastRun: "Τελευταίος Έλεγχος",
    numberOfRecordsChecked: "Αριθμός Εγγραφών που Ελέγχθηκαν",
    databaseFilter: "Φίλτρο που Χρησιμοποίηθηκε στην Βάση Δεδομένων",
    recordsThatIncludeErr: "Εγγραφές που περιέχουν τουλάχιστον μία από τις εξής αποκλίσεις",
    recordsThatDontIncludeErr: "Εγγραφές στις οποίες δεν βρέθηκε καμμία απόκλιση.",
    institution: 'Ίδρυμα',
    key: 'Συνθηματικό',
    emptyId: 'Το όνομα του Ιδρύματος δεν μπορεί να είναι κενό',
    emptyToken: 'Το συνθηματικό δεν μπορεί να είναι κενό',
    loginFailed: 'Τα στοιχεία πού δώσατε δεν ταιριάζουν',
    loginError: 'Αντιμετωπίζεται κάποιο πρόβλημα, δοκιμάστε ξανά αργότερα',
    errorTypeHeader: 'Αποκλίσεις που ανήκουν στην παραπάνω κατηγορία',
    propertyIdHeader: 'Αποκλίσεις που αφορόυν το παραπάνω πεδίο',
    grades: {
        '0': 'Χωρίς Αποκλίσεις',
        '1': 'Με Πολύ Χαμηλής Σοβαρότητας Αποκλίσεις',
        '2': 'Με Χαμηλής Σοβαρότητας Αποκλίσεις',
        '3': 'Με Μέτριας Σοβαρότητας Αποκλίσεις',
        '4': 'Με Αρκετά Σοβαρές Αποκλίσεις',
        '5': 'Με Πολύ Σοβαρές Αποκλίσεις',
        '6': 'Με Πάρα Πολύ Σοβαρές Αποκλίσεις'
    },
    severityDescriptions: {
        '1': 'Πολύ Χαμηλή Σοβαρότητα',
        '2': 'Χαμηλή Σοβαρότητα',
        '3': 'Μέτρια Σοβαρότητα',
        '4': 'Αρκετά Υψηλή Σοβαρότητα',
        '5': 'Πολύ Υψηλή Σοβαρότητα',
        '6': 'Πάρα Πολύ Υψηλή Σοβαρότητα',
    },
    errors: {
        '1': 'Άσκοπα κενά στην υπηκοότητα (citizenship) του Εθνικού Μητρώου ΑΜΚΑ',
        '2': 'Άσκοπα κενά στην ημερομηνία γέννησης (birthDate) του Εθνικού Μητρώου ΑΜΚΑ',
        '3': 'Άσκοπα κενά στην ένδειξη πλασματικής ημερομηνίας (bdate_istrue) του Εθνικού Μητρώου ΑΜΚΑ',
        '4': 'Άσκοπα κενά στο φύλο (gender) του Εθνικού Μητρώου ΑΜΚΑ',
        '5': 'Άσκοπα κενά στον ΑΦΜ (TIN) του Εθνικού Μητρώου ΑΜΚΑ',
        '6': 'Άσκοπα κενά στο επίθετο στα ελληνικά (lastNameEl) του Εθνικού Μητρώου ΑΜΚΑ',
        '7': 'Άσκοπα κενά στο επίθετο στα λατινικά (lastNameEn) του Εθνικού Μητρώου ΑΜΚΑ',
        '301': 'Ασυμφωνία ημερομηνίας γέννησης (birthDate) λόγω πλασματικής ημερομηνίας στο Εθνικό Μητρώο ΑΜΚΑ',
        '302': 'Μη έγκυρος ελληνικός ΑΦΜ (TIN) στο Εθνικό Μητρώο ΑΜΚΑ',
        '303': 'Κενή υπηκοότητα (citizenship) στο σύστημα του Ιδρύματος και το Εθνικό Μητρώο ΑΜΚΑ',
        '304': 'Κενό φύλο (gender) στο σύστημα του Ιδρύματος και το Εθνικό Μητρώο ΑΜΚΑ',
        '601': 'Λάθος μέγεθος στον ΑΦΜ (TIN) του Εθνικού Μητρώου ΑΜΚΑ',
        '602': 'Μη αριθμητική τιμη στον ΑΦΜ (TIN) του Εθνικού Μητρώου ΑΜΚΑ',
        '603': 'Κενός ΑΦΜ (TIN) στο Εθνικό μητρώο ΑΜΚΑ',
        '901': 'Κενή υπηκοότητα (citizenship) μόνο στο Εθνικό Μητρώο ΑΜΚΑ',
        '902': 'Κενή ημερομηνία γέννησης (birthDate) στο Εθνικό Μητρώο ΑΜΚΑ',
        '903': 'Λανθασμένη μορφοποίηση στην ημερομηνία γέννησης (birthDate) του Εθνικού Μητρώου ΑΜΚΑ',
        '904': 'Άγνωστη τιμή στην ένδειξη πλασματικής ημερομηνίας (bdate_istrue) του Εθνικού Μητρώου ΑΜΚΑ',
        '905': 'Κενό φύλο (gender) στο Εθνικό Μητρώο ΑΜΚΑ ενώ υπάρχει τιμή διαφορετική του 0 στο πεδίο gender στο σύστημα του Ιδρύματος',
        '906': 'Κενό επίθετο στα ελληνικά (lastNameEl) μόνο στο Εθνικό Μητρώο ΑΜΚΑ',
        '1001': 'Αριθμός κινητού τηλεφώνου (mobilePhone) με διεθνή κωδικό "00" αντί για "+" στο σύστημα του Ιδρύματος',
        '1002': 'Αριθμός κινητού τηλεφώνου (mobilePhone) χωρίς διεθνή κωδικό στο σύστημα του Ιδρύματος',
        '1101': 'Αριθμός κινητού τηλεφώνου (mobilePhone) μη κανονικοποιημένος στο σύστημα του Ιδρύματος',
        '1201': 'Άσκοπα κενά στον ΑΜΚΑ (SSN) στο σύστημα του Ιδρύματος',
        '1202': 'Άσκοπα κενά στην χώρα έκδοσης ΑΜΚΑ (SSNCOUNTRY) στο σύστημα του Ιδρύματος',
        '1203': 'Άσκοπα κενά στην υπηκοότητα (citizenship) στο σύστημα του Ιδρύματος',
        '1204': 'Άσκοπα κενά στην ημερομηνία γέννησης (birthDate) στο σύστημα του Ιδρύματος',
        '1205': 'Άσκοπα κενά στο έτος γέννησης (birthYear) στο σύστημα του Ιδρύματος',
        '1206': 'Άσκοπα κενά στο φύλο (gender) στο σύστημα του Ιδρύματος',
        '1207': 'Άσκοπα κενά στον ΑΦΜ (TIN) στο σύστημα του Ιδρύματος',
        '1208': 'Άσκοπα κενά στην χώρα έκδοσης ΑΦΜ (TINCOUNTRY) στο σύστημα του Ιδρύματος',
        '1209': 'Άσκοπα κενά στο επίθετο στα ελληνικά (lastNameEl) στο σύστημα του Ιδρύματος',
        '1210': 'Άσκοπα κενά στο επίθετο στα λατινικά (lastNameEn) στο σύστημα του Ιδρύματος',
        '1211': 'Άσκοπα κενά στον αριθμό κινητού τηλεφώνου (mobilePhone) στο σύστημα του Ιδρύματος',
        '1212': 'Άσκοπα κενά στο όνομα χρήστη (loginName) στο σύστημα του Ιδρύματος',
        '1501': 'Μη έγκυρος ελληνικός ΑΦΜ (TIN) στο σύστημα του Ιδρύματος',
        '1502': 'Μη αριθμητική τιμή στον αριθμό κινητού τηλεφώνου (mobilePhone) στο σύστημα του Ιδρύματος',
        '1503': 'Μη έγκυρη τιμή χώρας έκδοσης ΑΦΜ (TINCOUNTRY) στο σύστημα του Ιδρύματος',
        '1504': 'Μη έγκυρη τιμή τύπου συμμετοχής (attendanceType) στο σύστημα του Ιδρύματος',
        '1505': 'Το όνομα χρήστη (loginName) περιέχει τουλάχιστον έναν κεφαλαίο λατινικό χαρακτήρα',
        '1801': 'Μη συμπληρωμένος ΑΦΜ (TIN) ενώ είναι συμπληρωμένη η χώρα έκδοσης του στο σύστημα του Ιδρύματος',
        '1802': 'Μη συμπληρωμένη χώρα έκδοσης ΑΦΜ (TINCOUNTRY) ενώ είναι συμπληρωμένος ο ΑΦΜ (TIN) στο σύστημα του Ιδρύματος',
        '1803': 'Λάθος μέγεθος σε ελληνικό ΑΦΜ (TIN) στο σύστημα του Ιδρύματος',
        '1804': 'Μη αριθμητική τιμή σε ελληνικό ΑΦΜ (TIN) στο σύστημα του Ιδρύματος',
        '1805': 'Κενό επίθετο στα λατινικά (lastNameEn) στο Εθνικό Μητρώο ΑΜΚΑ',
        '1806': 'Μη έγκυρη τιμή αριθμού κινητού τηλεφώνου (mobilePhone) στο σύστημα του Ιδρύματος',
        '1807': 'Λάθος μέγεθος αριθμού κινητού τηλεφώνου (mobilePhone) στο σύστημα του Ιδρύματος',
        '1808': 'Μη έγκυρη τιμή κατάστασης λογαριασμού (accountStatus) στο σύστημα του Ιδρύματος',
        '1809': 'Λανθασμένη μορφοποίηση στο πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail) στο σύστημα του Ιδρύματος',
        '2101': 'Κενά επίθετο στα λατινικά (lastNameEn) και επίθετο στα ελληνικά (lastNameEl) στο Εθνικό Μητρώο ΑΜΚΑ',
        '2401': 'Ασυμφωνία ΑΦΜ (TIN) μεταξύ του συστήματος του Ιδρύματος και του Εθνικού Μητρώου ΑΜΚΑ',
        '2701': 'Μη έγκυρος ελληνικός ΑΜΚΑ (SSN) στο σύστημα του Ιδρύματος',
        '2702': 'Ο ΑΜΚΑ (SSN) δεν αντιστοιχεί σε εγγραφή στο Εθνικό Μητρώο ΑΜΚΑ',
        '3001': 'Κενή χώρα έκδοσης ΑΜΚΑ (SSNCOUNTRY) ενώ o ΑΜΚΑ (SSN) είναι συμπληρωμένος στο σύστημα του Ιδρύματος',
        '3002': 'Κενός ΑΜΚΑ (SSN) ενώ ως χώρα έκδοσης ΑΜΚΑ (SSNCOUNTRY) έχει δηλωθεί η Ελλάδα στο σύστημα του Ιδρύματος',
        '3301': 'Λάθος μέγεθος σε ελληνικό ΑΜΚΑ (SSN) στο σύστημα του Ιδρύματος',
        '3302': 'Μη αριθμητική τιμή σε ελληνικό ΑΜΚΑ (SSN) στο σύστημα του Ιδρύματος',
        '3303': 'Μη έγκυρη τιμή σε χώρα έκδοσης ΑΜΚΑ (SSNCOUNTRY) στο σύστημα του Ιδρύματος',
        '3304': 'Αριθμός χαρακτήρων στο όνομα χρήστη (loginName) εκτός των επιτρεπτών ορίων',
        '3401': 'Το όνομα πατρός στα Ελληνικά (fatherFirstNameEl) στο σύστημα του Ιδρύματος και το όνομα πατρός στα Ελληνικά στο Εθνικό Μητρώο ΑΜΚΑ παρουσιάζουν μεγάλη απόκλιση μεταξύ τους',
        '3402': 'Το όνομα πατρός στα Λατινικά (fatherFirstNameEn) στο σύστημα του Ιδρύματος και το όνομα πατρός στα Λατινικά στο Εθνικό Μητρώο ΑΜΚΑ παρουσιάζουν μεγάλη απόκλιση μεταξύ τους',
        '3403': 'Το όνομα μητρός στα Ελληνικά (motherFirstNameEl) στο σύστημα του Ιδρύματος και το όνομα μητρός στα Ελληνικά στο Εθνικό Μητρώο ΑΜΚΑ παρουσιάζουν μεγάλη απόκλιση μεταξύ τους',
        '3404': 'Το όνομα μητρός στα Λατινικά (motherFirstNameEn) στο σύστημα του Ιδρύματος και το όνομα μητρός στα Λατινικά στο Εθνικό Μητρώο ΑΜΚΑ παρουσιάζουν μεγάλη απόκλιση μεταξύ τους',
        '3405': 'Κενό όνομα πατρός στα Ελληνικά (fatherFirstNameEl) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '3406': 'Κενό όνομα πατρός στα Λατινικά (fatherFirstNameEn) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '3407': 'Κενό όνομα μητρος στα Ελληνικά (motherFirstNameEl) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '3408': 'Κενό όνομα μητρος στα Λατινικά (motherFirstNameEn) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '3601': 'Συμφωνία επιθέτου στα ελληνικά (lastNameEl) μόνο έπειτα από κανονικοποίηση ειδικών χαρακτήρων',
        '3602': 'Συμφωνία επιθέτου στα ελληνικά (lastNameEl) μόνο έπειτα από αφαίρεση διαχωριστικών',
        '3603': 'Συμφωνία επιθέτου στα λατινικά (lastNameEn) μόνο έπειτα από κανονικοποίηση ειδικών χαρακτήρων',
        '3604': 'Συμφωνία επιθέτου στα λατινικά (lastNameEn) μόνο έπειτα από αφαίρεση διαχωριστικών',
        '3801': 'Το μικρό όνομα στα Ελληνικά (firstNameEl) στο σύστημα του Ιδρύματος και το μικρό όνομα στα Ελληνικά στο Εθνικό Μητρώο ΑΜΚΑ παρουσιάζουν μεγάλη απόκλιση μεταξύ τους',
        '3802': 'Το μικρό όνομα στα Λατινικά (firstNameEn) στο σύστημα του Ιδρύματος και το μικρό όνομα στα Λατινικά στο Εθνικό Μητρώο ΑΜΚΑ παρουσιάζουν μεγάλη απόκλιση μεταξύ τους',
        '3803': 'Κενό μικρό όνομα στα Ελληνικά (firstNameEl) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '3804': 'Κενό μικρό όνομα στα Λατινικά (firstNameEn) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '4001': 'Κενό επίθετο στα ελληνικά (lastNameEl) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '4101': 'Κενό επίθετο στα λατινικά (lastNameEn) στο σύστημα του Ιδρύματος',
        '4201': 'Κενή υπηκοότητα (citizenship) στο σύστημα του Ιδρύματος ενώ υπάρχει στο Εθνικό Μητρώο ΑΜΚΑ',
        '4202': 'Κενή ημερομηνία γέννησης (birthDate) στο σύστημα του Ιδρύματος',
        '4203': 'Κενό έτος γέννησης (birthYear) στο σύστημα του Ιδρύματος',
        '4204': 'Μη έγκυρη ημερομηνία γέννησης (birthDate) στο σύστημα του Ιδρύματος',
        '4205': 'Μη έγκυρο έτος γέννησης (birthYear) στο σύστημα του Ιδρύματος',
        '4206': 'Κενό φύλο (gender) στο σύστημα του Ιδρύματος',
        '4207': 'Μη έγκυρη τιμή φύλου (gender) στο σύστημα του Ιδρύματος',
        '4208': 'Μη έγκυρη τιμή υπηκοότητας (citizenship) στο σύστημα του Ιδρύματος',
        '4209': 'Το όνομα χρήστη (loginName) περιέχει τουλάχιστον έναν μη επιτρεπτό χαρακτήρα',
        '4501': 'Κενό επίθετο στα ελληνικά (lastNameEl) και κενό επίθετο στα λατινικά (lastNameEn) στο σύστημα του Ιδρύματος',
        '4502': 'Μη έγκυρη τιμή σπουδαστικής κατάστασης (enrollmentStatus) στο σύστημα του Ιδρύματος',
        '4503': 'Μη έγκυρη τιμή τύπου εγγραφής (enrollmentType) στο σύστημα του Ιδρύματος',
        '4504': 'Κενή ημερομηνία μεταβολής σπουδαστικής κατάστασης (enrollmentStatusDate) στο σύστημα του Ιδρύματος',
        '4505': 'Λανθασμένη μορφοποίηση στην ημερομηνία μεταβολής σπουδαστικής κατάστασης (enrollmentStatusDate) στο σύστημα του Ιδρύματος',
        '4801': 'Ασυμφωνία ημερομηνίας γέννησης (birthDate) μεταξύ του συστήματος του Ιδρύματος και του Εθνικού Μητρώου ΑΜΚΑ',
        '5101': 'Ασυμφωνία υπηκοότητας (citizenship) μεταξύ του συστήματος του Ιδρύματος και του Εθνικού Μητρώου ΑΜΚΑ',
        '5102': 'Ασυμφωνία έτους γέννησης (birthYear) μεταξύ του συστήματος του Ιδρύματος και του Εθνικού Μητρώου ΑΜΚΑ',
        '5103': 'Ασυμφωνία φύλου (gender) μεταξύ του συστήματος του Ιδρύματος και του Εθνικού Μητρώου ΑΜΚΑ',
        '5104': 'Ασυμφωνία επιθέτου στα ελληνικά (lastNameEl) μεταξύ του συστήματος του Ιδρύματος και του Εθνικού Μητρώου ΑΜΚΑ',
        '5105': 'Ασυμφωνία επιθέτου στα λατινικά (lastNameEn) μεταξύ του συστήματος του Ιδρύματος και του Εθνικού Μητρώου ΑΜΚΑ',
        '5106': 'Η τιμή του ονόματος στα ελληνικά (firstNameEl) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)' ,
        '5107': 'Η τιμή του ονόματος στα λατινικά (firstNameEn) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5108': 'Η τιμή του επιθέτoυ στα ελληνικά (lastNameEl) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5109': 'Η τιμή του επιθέτoυ στα λατινικά (lastNameEn) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5110': 'Η τιμή του ΑΜΚΑ (SSN) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5111': 'Η τιμή της χώρας έκδοσης ΑΜΚΑ (SSN_COUNTRY) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5112': 'Η τιμή του ΑΦΜ (TIN) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5113': 'Η τιμή της χώρας έκδοσης ΑΦΜ (TIN_COUNTRY) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5114': 'Η τιμή της ημερομηνίας γέννησης (birthDate) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5115': 'Η τιμή του έτους γέννησης (birthYear) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο ονόματος χρήστη (loginName)',
        '5116': 'Η τιμή του ονόματος στα ελληνικά (firstNameEl) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5117': 'Η τιμή του ονόματος στα λατινικά (firstNameEn) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5118': 'Η τιμή του επιθέτου στα ελληνικά (lastNameEl) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5119': 'Η τιμή του επιθέτου στα λατινικά (lastNameEn) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5120': 'Η τιμή του ΑΜΚΑ (SSN) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5121': 'Η τιμή της χώρας έκδοσης ΑΜΚΑ (SSN_COUNTRY) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5122': 'Η τιμή του ΑΦΜ (TIN) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5123': 'Η τιμή της χώρας έκδοσης του ΑΦΜ (TIN_COUNTRY) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5124': 'Η τιμή της ημερομηνίας γέννησης (birthDate) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5125': 'Η τιμή του έτους γέννησης (birthYear) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο αριθμού τηλεφώνου (mobilePhone)',
        '5126': 'Η τιμή του ονόματος στα ελληνικά (firstNameEl) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5127': 'Η τιμή του ονόματος στα λατινικά (firstNameEn) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5128': 'Η τιμή του επιθέτου στα ελληνικά (lastNameEl) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5129': 'Η τιμή του επιθέτου στα λατινικά (lastNameEn) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5130': 'Η τιμή του ΑΜΚΑ (SSN) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5131': 'Η τιμή της χώρας έκδοσης ΑΜΚΑ (SSN_COUNTRY) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5132': 'Η τιμή του ΑΦΜ (TIN) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5133': 'Η τιμή της χώρας έκδοσης του ΑΦΜ (TIN_COUNTRY) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5134': 'Η τιμή της ημερομηνίας γέννησης (birthDate) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',
        '5135': 'Η τιμή του έτους γέννησης (birthYear) δεν συμφωνεί με την αντίστοιχη τιμή σε άλλη εγγραφή με κοινό το πεδίο της διεύθυνσης ηλεκτρονικού ταχυδρομείου (extEmail)',

        '5401': 'Το πεδίο Registration Id (registrationID) στο πληροφοριακό σύστημα του Ιδρύματος περιέχει τιμή που υπάρχει σε πάνω από μία εγγραφές',
        '5402': 'Το πεδίο System Id (systemID) στο πληροφοριακό σύστημα του Ιδρύματος περιέχει τιμή που υπάρχει σε πάνω από μία εγγραφές',

    },
    errorsProperty: {
        'birthdate': 'Ημερομηνία Γέννησης',
        'birthyear': 'Έτος Γέννησης',
        'birthΥear': 'Έτος Γέννησης',
        'lastNameEl': 'Επίθετο στα Ελληνικά',
        'lastNameEn': 'Επίθετο στα Λατινικά',
        'firstNameEl': 'Όνομα στα Ελληνικά',
        'firstNameEn': 'Όνομα στα Λατινικά',
        'fatherFirstNameEl': 'Όνομα πατρός στα Ελληνικά',
        'fatherFirstNameEn': 'Όνομα πατρός στα Λατινικά',
        'motherFirstNameEl': 'Όνομα μητρός στα Ελληνικά',
        'motherFirstNameEn': 'Όνομα μητρός στα Λατινικά',
        'ssn': 'ΑΜΚΑ',
        'tin': 'ΑΦΜ',
        'ssnCountry': 'Χώρα Έκδοσης ΑΜΚΑ',
        'tinCountry': 'Χώρα Έκδοσης ΑΦΜ',
        'ssncountry': 'Χώρα Έκδοσης ΑΜΚΑ',
        'tincountry': 'Χώρα Έκδοσης ΑΦΜ',
        'gender': 'Φύλο',
        'citizenship': 'Υπηκοότητα',
        'mobilePhone': 'Αριθμός Κινητού Τηλεφώνου',
        'mobile': 'Αριθμός Κινητού Τηλεφώνου',
        'bdate_istrue': 'Ένδειξη Πλασματικής Ημερομηνίας',
        'enrollmentStatus': 'Σπουδαστική Κατάσταση',
        'enrollmentType': 'Τύπος Εγγραφής',
        'enrollmentStatusDate': 'Ημερομηνία Μεταβολής Σπουδαστικής Κατάστασης',
        'accountStatus': 'Κατάσταση Λογαριασμού',
        'loginName' : 'Όνομα Χρήστη',
        'systemID': 'System ID',
        'registrationID': 'Registration ID',
        'extEmail': 'Διεύθυνση Ηλεκτρονικού Ταχυδρομείου'
    },
    errorsType: {
        'trimming': 'Κενοί Χαρακτήρες',
        'normalization': 'Κανονικοποίηση',
        'invalid-format': 'Μη Έγκυρη Μορφή',
        'invalidValue': 'Μη Έγκυρη Τιμή',
        'invalid-value': 'Μη Έγκυρη Τιμή',
        'null-value': 'Κενή Τιμή',
        'missmatch': 'Ασυμφωνία'
    },
    trimmingDesc: 'Η τιμή του πεδίου περιέχει κενούς χαρακτήρες στην αρχή ή στο τέλος',
    normalizationDesc: 'Η τιμή του πεδίου είναι σωστή μόνο έπειτα από κανονικοποίηση διαχωριστικών, τόνων ή ειδικών χαρακτήρων',
    invalidFormatDesc: 'Η τιμή του πεδίου δεν ακολουθεί την σωστή μορφοποίηση',
    invalidValueDesc: 'Το πεδίο περίεχει τιμή που δεν συμφωνεί με τον τύπο του',
    nullValueDesc: 'Το πεδίο δεν έχει συμπληρωθεί',
    missmatchDesc: 'Η τιμή του πεδίου στο σύστημα δεν ταιριάζει με την αντίστοιχη τιμή στο Εθνικό Μητρώο ΑΜΚΑ',
    Checks: {
        checksResults: 'Αποτελέσματα Ελέγχων',
        recordsWErrors: 'Εγγραφές με Αποκλίσεις',
        numOfRecordsWErrors: 'Αριθμός Εγγραφών με Αποκλίσεις',
        downloadResultsFile: 'Κατέβασμα Αρχείου Αποτελεσμάτων',
        numOfErrors: 'Συνολικός Αριθμός Αποκλίσεων',
        noResultsFileAvailable: 'Δεν υπάρχει διαθέσιμο αρχείο αποτελεσμάτων',
        numOfFilteredResults: 'Αριθμός Φιλτραρισμένων Αποτελεσμάτων',
        registrationId: 'Registration Id',
        systemId: 'System Id',
        department: 'Τμήμα',
        errorType: 'Είδος Απόκλισης',
        field: 'Πεδία',
        severity: 'Σοβαρότητα',
        filters: 'Φίλτρα',
        clear: 'Καθαρισμός',
        errorFilters: 'Πεδία Αποκλίσεων',
        studentFilters: 'Πεδία Φοιτητή',
        identifiers: 'Αναγνωριστικά',
        contact: 'Επικοινωνία',
        studies: 'Σπουδές',
        names: 'Ονοματεπωνυμικά',
        account: 'Λογαριασμός',
        personalInfo: 'Προσωπικά Στοιχεία',
        cancel: 'Ακύρωση',
        continue: 'Συνέχεια',
        fields: 'Πεδία',
        errortypes: 'Είδη',
        departments: 'Τμήμα',
        sortBy: 'Ταξινόμηση'
    },
    Record: {
        errors: 'Αποκλίσεις',
        numOfRecordErrors: 'Αριθμός Αποκλίσεων Εγγραφής',
        backToResults: 'Πίσω στα Αποτελέσματα',
        moreData: 'Περισσότερα',
        moreRecordData: 'Αναλυτικά Στοιχεία Εγγραφής',
        close: 'Κλείσιμο',
        notify: 'Ειδοποίηση Φοιτητή',
        department: 'Τμήμα',
        severity: 'Σοβαρότητα',
        name: 'Ονοματεπώνυμο',
        identifiers: 'Αναγνωριστικά',
        contact: 'Επικοινωνία',
        studies: 'Σπουδές',
        names: 'Ονοματεπωνυμικά',
        account: 'Λογαριασμός',
        personalInfo: 'Προσωπικά Στοιχεία',
        cancel: 'Ακύρωση',
        continue: 'Συνέχεια',
        fields: 'Πεδία',
        errortypes: 'Είδη',
        departments: 'Τμήμα',
        sortBy: 'Ταξινόμηση',
        fields: {
            'registrationID': 'Registration Id',
            'systemID': 'System Id',
            'ssn': 'ΑΜΚΑ',
            'ssnCountry': 'Χώρα Έκδοσης ΑΜΚΑ',
            'tin': 'ΑΦΜ',
            'tinCountry': 'Χώρα Έκδοσης ΑΦΜ',
            'lastNameEl': 'Επίθετο (Ελληνικά)',
            'lastNameEn': 'Επίθετο (Λατινικά)',
            'firstNameEl': 'Όνομα (Ελληνικά)',
            'firstNameEn': 'Όνομα (Λατινικά)',
            'fatherFirstNameEl': 'Όνομα Πατρός (Ελληνικά)',
            'fatherFirstNameEn': 'Όνομα Πατρός (Λατινικά)',
            'motherFirstNameEl': 'Όνομα Μητρός (Ελληνικά)',
            'motherFirstNameEn': 'Όνομα Μητρός (Λατινικά)',
            'enrollmentStatus': 'Σπουδαστική Κατάσταση',
            'enrollmentStatusDate': 'Ημ/νία Μεταβολής Σπουδαστικής Κατάστασης',
            'enrollmentTerm': 'Σπουδαστικό Εξάμηνο',
            'enrollmentType': 'Τύπος Εγγραφής',
            'attendanceType': 'Τύπος Συμμετοχής',
            'loginName': 'Όνομα Χρήστη',
            'accountStatus': 'Κατάσταση Λογαριασμού',
            'extEmail': 'Διεύθυνση Ηλ. Ταχυδρομείου',
            'mobilePhone': 'Αριθμός Κιν. Τηλεφώνου',
            'birthDate': 'Ημ/νία Γέννησης',
            'birthYear': 'Έτος Γέννησης',
            'gender': 'Φύλο',
            'citizenship': 'Υπηκοότητα'
        }
    },
    Notify: {
        'notifyStudent': 'Ειδοποίηση Φοιτητή',
        'description1': 'Ο φοιτητής που αντιστοιχεί στην συγκεκριμένη εγγραφή θα ειδοποιηθεί μέσω ',
        'sms': 'SMS',
        'description2': 'στον αριθμό κινητού τηλεφώνου ο οποίος είναι καταχωρημένος στο σύστημα, σχετικά με τις αποκλίσεις που βρέθηκαν στην εγγραφή.',
        'mobilePhone': 'Αριθμός Κινητού Τηλεφώνου',
        'about': 'Σχετικά με',
        'messagePreview': 'Προβολή Μηνύματος',
        'cancel': 'Ακύρωση',
        'send': 'Αποστολή',
        'messageWasSuccessfullySent': 'Το μήνυμα στάλθηκε επιτυχώς',
        'messageWasNotSuccessfullySent': 'Η αποστολή του μηνύματος απέτυχε',
        'close': 'Κλείσιμο',
        'errorSelection': {
            'allErrors': 'Όλες τις Αποκλίσεις',
            'viewErrors': 'Αποκλίσεις στο πληροφοριακό σύστημα του Ιδρύματος',
            'ssnRegistryErrors': 'Αποκλίσεις στο Εθνικό Μητρώο ΑΜΚΑ'
        }
    },
    Dropdown: {
        fields: {
            label: 'Πεδία',
            all: 'Όλα',
            'birthdate': 'Ημερομηνία Γέννησης',
            'birthyear': 'Έτος Γέννησης',
            'lastNameEl': 'Επίθετο στα Ελληνικά',
            'lastNameEn': 'Επίθετο στα Λατινικά',
            'firstNameEl': 'Όνομα στα Ελληνικά',
            'firstNameEn': 'Όνομα στα Λατινικά',
            'fatherFirstNameEl': 'Όνομα πατρός στα Ελληνικά',
            'fatherFirstNameEn': 'Όνομα πατρός στα Λατινικά',
            'motherFirstNameEl': 'Όνομα μητρός στα Ελληνικά',
            'motherFirstNameEn': 'Όνομα μητρός στα Λατινικά',
            'ssn': 'ΑΜΚΑ',
            'tin': 'ΑΦΜ',
            'ssnCountry': 'Χώρα Έκδοσης ΑΜΚΑ',
            'tinCountry': 'Χώρα Έκδοσης ΑΦΜ',
            'ssncountry': 'Χώρα Έκδοσης ΑΜΚΑ',
            'tincountry': 'Χώρα Έκδοσης ΑΦΜ',
            'gender': 'Φύλο',
            'citizenship': 'Υπηκοότητα',
            'mobilePhone': 'Αριθμός Κινητού Τηλεφώνου',
            'bdate_istrue': 'Ένδειξη Πλασματικής Ημερομηνίας',
            'enrollmentStatus': 'Σπουδαστική Κατάσταση',
            'enrollmentType': 'Τύπος Εγγραφής',
            'enrollmentStatusDate': 'Ημερομηνία Μεταβολής Σπουδαστικής Κατάστασης',
            'accountStatus': 'Κατάσταση Λογαριασμού',
            'loginName' : 'Όνομα Χρήστη',
            'systemID': 'System ID',
            'registrationID': 'Registration ID',
            'extEmail': 'Διεύθυνση Ηλεκτρονικού Ταχυδρομείου',

            explanations: {
                'birthdate': 'birthDate',
                'birthyear': 'birthYear',
                'lastNameEl': 'lastNameEl',
                'lastNameEn': 'lastNameEn',
                'firstNameEl': 'firstNameEl',
                'firstNameEn': 'firstNameEn',
                'fatherFirstNameEl': 'fatherFirstNameEl',
                'fatherFirstNameEn': 'fatherFirstNameEn',
                'motherFirstNameEl': 'motherFirstNameEl',
                'motherFirstNameEn': 'motherFirstNameEn',
                'ssn': 'SSN',
                'tin': 'TIN',
                'ssnCountry': 'SSN_COUNTRY',
                'tinCountry': 'TIN_COUNTRY',
                'ssncountry': 'SSN_COUNTRY',
                'tincountry': 'TIN_COUNTRY',
                'gender': 'gender',
                'citizenship': 'citizenship',
                'mobilePhone': 'mobilePhone',
                'bdate_istrue': 'bdate_istrue',
                'enrollmentStatus': 'enrollmentStatus',
                'enrollmentType': 'enrollmentType',
                'enrollmentStatusDate': 'enrollmentStatusDate',
                'accountStatus': 'accountStatus',
                'loginName' : 'loginName',
                'systemID': 'systemID',
                'registrationID': 'registrationID',
                'extEmail': 'extEmail',
            }
        },
        errorTypes: {
            'label': 'Είδη',
            'all': 'Όλα',
            'trimming': 'Κενοί Χαρακτήρες',
            'normalization': 'Κανονικοποίηση',
            'invalid-format': 'Μη Έγκυρη Μορφή',
            'invalidValue': 'Μη Έγκυρη Τιμή',
            'invalid-value': 'Μη Έγκυρη Τιμή',
            'null-value': 'Κενή Τιμή',
            'missmatch': 'Ασυμφωνία'
        },
        errorCodes: {
            'label': 'Κωδικοί Αποκλίσεων',
            'all': 'Όλοι'
        },
        severityGroup: {
            'label': 'Σοβαρότητα',
            'all': 'Όλες',
            '1': 'Πολύ Χαμηλή Σοβαρότητα',
            '2': 'Χαμηλή Σοβαρότητα',
            '3': 'Μέτρια Σοβαρότητα',
            '4': 'Αρκετά Υψηλή Σοβαρότητα',
            '5': 'Πολύ Υψηλή Σοβαρότητα',
            '6': 'Πάρα Πολύ Υψηλή Σοβαρότητα',
        },
        department: {
            'label': 'Τμήμα'
        },
        'sortingRecords': {
            'registrationID-hl': 'Registration ID (Φθήνουσα)',
            'registrationID-lh': 'Registration ID (Αύξουσα)',
            'systemID-hl': 'System ID (Φθήνουσα)',
            'systemID-lh': 'System ID (Αύξουσα)',
            'department-hl': 'Τμήμα (Φθήνουσα)',
            'department-lh': 'Τμήμα (Αύξουσα)',
            'severity-hl': 'Σοβαρότητα (Φθήνουσα)',
            'severity-lh': 'Σοβαρότητα (Αύξουσα)',
            'label': 'Ταξινόμιση',
        },
        'sortingErrors': {
            'severity-hl': 'Σοβαρότητα (Φθήνουσα)',
            'severity-lh': 'Σοβαρότητα (Αύξουσα)',
            'errorCode-hl': 'Κωδικός Απόκλισης (Φθήνουσα)',
            'errorCode-lh': 'Κωδικός Απόκλισης (Αύξουσα)',
            'errorType-hl': 'Είδος Απόκλισης (Φθήνουσα)',
            'errorType-lh': 'Είδος Απόκλισης (Αύξουσα)',
            'label': 'Ταξινόμιση',
        },
        'enrollmentStatusDateType': {
            'period': 'Διάστημα',
            'single': 'Ημέρα'
        }, 
        'enrollmentTermType': {
            'period': 'Διάστημα',
            'single': 'Εξάμηνο'
        }
    }, 
    Pills: {
        selections: {
            fields: {
                fields: 'Πεδία',
                all: 'Όλα',
                'birthdate': 'Ημερομηνία Γέννησης',
                'birthyear': 'Έτος Γέννησης',
                'lastNameEl': 'Επίθετο στα Ελληνικά',
                'lastNameEn': 'Επίθετο στα Λατινικά',
                'firstNameEl': 'Όνομα στα Ελληνικά',
                'firstNameEn': 'Όνομα στα Λατινικά',
                'fatherFirstNameEl': 'Όνομα πατρός στα Ελληνικά',
                'fatherFirstNameEn': 'Όνομα πατρός στα Λατινικά',
                'motherFirstNameEl': 'Όνομα μητρός στα Ελληνικά',
                'motherFirstNameEn': 'Όνομα μητρός στα Λατινικά',
                'ssn': 'ΑΜΚΑ',
                'tin': 'ΑΦΜ',
                'ssnCountry': 'Χώρα Έκδοσης ΑΜΚΑ',
                'tinCountry': 'Χώρα Έκδοσης ΑΦΜ',
                'ssncountry': 'Χώρα Έκδοσης ΑΜΚΑ',
                'tincountry': 'Χώρα Έκδοσης ΑΦΜ',
                'gender': 'Φύλο',
                'citizenship': 'Υπηκοότητα',
                'mobilePhone': 'Αριθμός Κινητού Τηλεφώνου',
                'bdate_istrue': 'Ένδειξη Πλασματικής Ημερομηνίας',
                'enrollmentStatus': 'Σπουδαστική Κατάσταση',
                'enrollmentType': 'Τύπος Εγγραφής',
                'enrollmentStatusDate': 'Ημ/νία Μεταβολής Σπουδαστικής Κατάστασης',
                'accountStatus': 'Κατάσταση Λογαριασμού',
                'loginName' : 'Όνομα Χρήστη',
                'systemID': 'System ID',
                'registrationID': 'Registration ID',
                'extEmail': 'Διεύθυνση Ηλεκτρονικού Ταχυδρομείου',
            },
            errorTypes: {
                'errorTypes': 'Είδη',
                'all': 'Όλα',
                'trimming': 'Κενοί Χαρακτήρες',
                'normalization': 'Κανονικοποίηση',
                'invalid-format': 'Μη Έγκυρη Μορφή',
                'invalidValue': 'Μη Έγκυρη Τιμή',
                'invalid-value': 'Μη Έγκυρη Τιμή',
                'null-value': 'Κενή Τιμή',
                'missmatch': 'Ασυμφωνία'
            },
            severityGroups: {
                'severityGroups': 'Σοβαρότητα',
                'all': 'Όλα',
                '1': 'Πολύ Χαμηλή Σοβαρότητα',
                '2': 'Χαμηλή Σοβαρότητα',
                '3': 'Μέτρια Σοβαρότητα',
                '4': 'Αρκετά Υψηλή Σοβαρότητα',
                '5': 'Πολύ Υψηλή Σοβαρότητα',
                '6': 'Πάρα Πολύ Υψηλή Σοβαρότητα',
            },
            errorCodes: {
                 '1': 'Απόκλιση 1',
                 '2': 'Απόκλιση 2',
                 '3': 'Απόκλιση 3',
                 '4': 'Απόκλιση 4',
                 '5': 'Απόκλιση 5',
                 '6': 'Απόκλιση 6',
                 '7': 'Απόκλιση 7',
                 '301': 'Απόκλιση 301',
                 '302': 'Απόκλιση 302',
                 '303': 'Απόκλιση 303',
                 '304': 'Απόκλιση 304',
                 '601': 'Απόκλιση 601',
                 '602': 'Απόκλιση 602',
                 '603': 'Απόκλιση 603',
                 '901': 'Απόκλιση 901',
                 '902': 'Απόκλιση 902',
                 '903': 'Απόκλιση 903',
                 '904': 'Απόκλιση 904',
                 '905': 'Απόκλιση 905',
                 '906': 'Απόκλιση 906',
                 '1001': 'Απόκλιση 1001',
                 '1002': 'Απόκλιση 1002',
                 '1101': 'Απόκλιση 1101',
                 '1201': 'Απόκλιση 1201',
                 '1203': 'Απόκλιση 1203',
                 '1204': 'Απόκλιση 1204',
                 '1205': 'Απόκλιση 1205',
                 '1206': 'Απόκλιση 1206',
                 '1207': 'Απόκλιση 1207',
                 '1208': 'Απόκλιση 1208',
                 '1209': 'Απόκλιση 1209',
                 '1210': 'Απόκλιση 1210',
                 '1211': 'Απόκλιση 1211',
                 '1212': 'Απόκλιση 1212',
                 '1501': 'Απόκλιση 1501',
                 '1502': 'Απόκλιση 1502',
                 '1503': 'Απόκλιση 1503',
                 '1505': 'Απόκλιση 1505',
                 '1801': 'Απόκλιση 1801',
                 '1802': 'Απόκλιση 1802',
                 '1803': 'Απόκλιση 1803',
                 '1804': 'Απόκλιση 1804',
                 '1805': 'Απόκλιση 1805',
                 '1807': 'Απόκλιση 1807',
                 '1807': 'Απόκλιση 1807',
                 '1808': 'Απόκλιση 1808',
                 '1809': 'Απόκλιση 1809',
                 '2101': 'Απόκλιση 2101',
                 '2401': 'Απόκλιση 2401',
                 '2701': 'Απόκλιση 2701',
                 '2702': 'Απόκλιση 2702',
                 '3001': 'Απόκλιση 3001',
                 '3002': 'Απόκλιση 3002',
                 '3301': 'Απόκλιση 3301',
                 '3302': 'Απόκλιση 3302',
                 '3303': 'Απόκλιση 3303',
                 '3304': 'Απόκλιση 3304',
                 '3401': 'Απόκλιση 3401',
                 '3402': 'Απόκλιση 3402',
                 '3403': 'Απόκλιση 3403',
                 '3404': 'Απόκλιση 3404',
                 '3405': 'Απόκλιση 3405',
                 '3406': 'Απόκλιση 3406',
                 '3407': 'Απόκλιση 3407',
                 '3408': 'Απόκλιση 3408',
                 '3601': 'Απόκλιση 3601',
                 '3602': 'Απόκλιση 3602',
                 '3603': 'Απόκλιση 3603',
                 '3604': 'Απόκλιση 3604',
                 '3801': 'Απόκλιση 3801',
                 '3802': 'Απόκλιση 3802',
                 '3803': 'Απόκλιση 3803',
                 '3804': 'Απόκλιση 3804',
                 '4001': 'Απόκλιση 4001',
                 '4101': 'Απόκλιση 4101',
                 '4201': 'Απόκλιση 4201',
                 '4202': 'Απόκλιση 4202',
                 '4203': 'Απόκλιση 4203',
                 '4204': 'Απόκλιση 4204',
                 '4205': 'Απόκλιση 4205',
                 '4206': 'Απόκλιση 4206',
                 '4207': 'Απόκλιση 4207',
                 '4208': 'Απόκλιση 4208',
                 '4209': 'Απόκλιση 4209',
                 '4501': 'Απόκλιση 4501',
                 '4502': 'Απόκλιση 4502',
                 '4503': 'Απόκλιση 4503',
                 '4504': 'Απόκλιση 4504',
                 '4505': 'Απόκλιση 4505',
                 '4801': 'Απόκλιση 4801',
                 '5101': 'Απόκλιση 5101',
                 '5102': 'Απόκλιση 5102',
                 '5103': 'Απόκλιση 5103',
                 '5104': 'Απόκλιση 5104',
                 '5105': 'Απόκλιση 5105',
                 '5106': 'Απόκλιση 5106',
                 '5107': 'Απόκλιση 5107',
                 '5108': 'Απόκλιση 5108',
                 '5109': 'Απόκλιση 5109',
                 '5110': 'Απόκλιση 5110',
                 '5111': 'Απόκλιση 5111',
                 '5112': 'Απόκλιση 5112',
                 '5113': 'Απόκλιση 5113',
                 '5114': 'Απόκλιση 5114',
                 '5115': 'Απόκλιση 5115',
                 '5116': 'Απόκλιση 5116',
                 '5117': 'Απόκλιση 5117',
                 '5118': 'Απόκλιση 5118',
                 '5119': 'Απόκλιση 5119',
                 '5120': 'Απόκλιση 5120',
                 '5121': 'Απόκλιση 5121',
                 '5122': 'Απόκλιση 5122',
                 '5123': 'Απόκλιση 5123',
                 '5124': 'Απόκλιση 5124',
                 '5125': 'Απόκλιση 5125',
                 '5126': 'Απόκλιση 5126',
                 '5127': 'Απόκλιση 5127',
                 '5128': 'Απόκλιση 5128',
                 '5129': 'Απόκλιση 5129',
                 '5130': 'Απόκλιση 5130',
                 '5131': 'Απόκλιση 5131',
                 '5132': 'Απόκλιση 5132',
                 '5133': 'Απόκλιση 5133',
                 '5134': 'Απόκλιση 5134',
                 '5135': 'Απόκλιση 5135',
                 '5401': 'Απόκλιση 5401',
                 '5402': 'Απόκλιση 5402',
            }
        }, 
        fields: {
                'registrationID': 'Registration Id',
                'systemID': 'System Id',
                'ssn': 'ΑΜΚΑ',
                'ssnCountry': 'Χώρα Έκδοσης ΑΜΚΑ',
                'tin': 'ΑΦΜ',
                'tinCountry': 'Χώρα Έκδοσης ΑΦΜ',
                'lastNameEl': 'Επίθετο (Ελληνικά)',
                'lastNameEn': 'Επίθετο (Λατινικά)',
                'firstNameEl': 'Όνομα (Ελληνικά)',
                'firstNameEn': 'Όνομα (Λατινικά)',
                'fatherFirstNameEl': 'Όνομα Πατρός (Ελληνικά)',
                'fatherFirstNameEn': 'Όνομα Πατρός (Λατινικά)',
                'motherFirstNameEl': 'Όνομα Μητρός (Ελληνικά)',
                'motherFirstNameEn': 'Όνομα Μητρός (Λατινικά)',
                'enrollmentStatus': 'Σπουδαστική Κατάσταση',
                'enrollmentStatusDate': 'Ημ/νία Μεταβολής Σπουδαστικής Κατάστασης',
                'enrollmentStatusDateFrom': 'Ημερομηνία Μεταβολής Σπουδαστικής Κατάστασης (Από)',
                'enrollmentStatusDateTo': 'Ημερομηνία Μεταβολής Σπουδαστικής Κατάστασης (Μέχρι)',
                'enrollmentType': 'Τύπος Εγγραφής',
                'enrollmentTerm': 'Σπουδαστικό Εξάμηνο',
                'enrollmentTermFrom': 'Σπουδαστικό Εξάμηνο (Από)',
                'enrollmentTermTo': 'Σπουδαστικό Εξάμηνο (Μέχρι)',
                'attendanceType': 'Τύπος Συμμετοχής',
                'loginName': 'Όνομα Χρήστη',
                'accountStatus': 'Κατάσταση Λογαριασμού',
                'extEmail': 'Διεύθυνση Ηλ. Ταχυδρομείου',
                'mobilePhone': 'Αριθμός Κιν. Τηλεφώνου',
                'birthDate': 'Ημ/νία Γέννησης',
                'birthYear': 'Έτος Γέννησης',
                'gender': 'Φύλο',
                'citizenship': 'Υπηκοότητα',
                'departmentID': 'Τμήμα',
                'severityGroup': 'Σοβαρότητα'
        }
        
    },
    Filters: {
        'department': 'Τμήμα',
        'registrationID': 'Registration Id',
        'systemID': 'System Id',
        'ssn': 'ΑΜΚΑ',
        'ssnCountry': 'Χώρα Έκδοσης ΑΜΚΑ',
        'tin': 'ΑΦΜ',
        'tinCountry': 'Χώρα Έκδοσης ΑΦΜ',
        'lastNameEl': 'Επίθετο (Ελληνικά)',
        'lastNameEn': 'Επίθετο (Λατινικά)',
        'firstNameEl': 'Όνομα (Ελληνικά)',
        'firstNameEn': 'Όνομα (Λατινικά)',
        'fatherFirstNameEl': 'Όνομα Πατρός (Ελληνικά)',
        'fatherFirstNameEn': 'Όνομα Πατρός (Λατινικά)',
        'motherFirstNameEl': 'Όνομα Μητρός (Ελληνικά)',
        'motherFirstNameEn': 'Όνομα Μητρός (Λατινικά)',
        'enrollmentType': 'Τύπος Εγγραφής',
        'enrollmentStatus': 'Σπουδαστική Κατάσταση',
        'enrollmentStatusDate': 'Ημ/νία Μεταβολής Σπουδαστικής Κατάστασης',
        'enrollmentStatusDateFrom': 'Ημ/νία Μεταβολής Σπουδαστικής Κατάστασης (Από)',
        'enrollmentStatusDateTo': 'Ημ/νία Μεταβολής Σπουδαστικής Κατάστασης (Μέχρι)',
        'enrollmentTerm': 'Σπουδαστικό Εξάμηνο',
        'enrollmentTermFrom': 'Σπουδαστικό Εξάμηνο (Από)',
        'enrollmentTermTo': 'Σπουδαστικό Εξάμηνο (Μέχρι)',
        'attendanceType': 'Τύπος Συμμετοχής',
        'loginName': 'Όνομα Χρήστη',
        'accountStatus': 'Κατάσταση Λογαριασμού',
        'extEmail': 'Διεύθυνση Ηλ. Ταχυδρομείου',
        'mobilePhone': 'Αριθμός Κιν. Τηλεφώνου',
        'birthDate': 'Ημ/νία Γέννησης',
        'birthYear': 'Έτος Γέννησης',
        'gender': 'Φύλο',
        'citizenship': 'Υπηκοότητα'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/locale-el.js